import React, { useEffect, useState } from "react"
import {
  Form,
  Modal,
  notification,
  Row,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
} from "../../../app/applicationSlice"
import moment from "moment"
import { AXIOS_IP, generateTempId } from "../fileUploadService"
import { EditableList } from "../../../compnents/list/EditableList"
import { KZLYWCatalogColumns } from "../columns"
import { validateArrayDataFirstError, validateRequiredFields } from "../AntimicrobialDrugs/validate"

export const KZLYWFormModal = (props: {
  visible: boolean
  token: string
  againId?: string
  memo?: string
  isFiling?: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [pageLoading, setPageLoading] = useState(false)

  const [data, setData] = useState<any[]>([])

  const requiredList = [
    { name: "分类", key: "parentValue", required: true },
    { name: "药品通用名", key: "drugName", required: true },
    { name: "规格", key: "specification", required: true },
    { name: "使用权限", key: "usagePermission", required: true },
  ]

  useEffect(() => {
    if (props.visible) {
      if(props.againId) {
        setPageLoading(true)
        axios({
          url: `${AXIOS_IP}/filingAnticancerDrugInfo/list`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { [props.isFiling ? "filingAnticancerDrugRecordId" : "filingReviewAnticancerDrugRecordId"]: props.againId, pageNo: 1, pageSize: 100 },
        }).then((res) => {
          const data = res.data.data
          setData(data?.records?.concat([{ id: generateTempId() }]) || [{ id: generateTempId() }])
        }).catch((err) => { console.error(err) }).finally(() => {
          setPageLoading(false)
        })
      } else {
        if (!data.length) {
          setData([{ id: generateTempId() }])
        }
      }
    } else {
      setData([])
    }
  }, [props.visible, props.againId])

  return (
    <>
      <Modal
        title="抗肿瘤药物分级管理目录备案"
        width={1300}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={() => {
          const msg = validateArrayDataFirstError(data?.slice(0, -1), requiredList)
          if(data?.length <= 1) {
            return
          }
          if (msg.isValid) {
            setSubmitVisible(true)
          } else {
            notification.warning({
              message: msg.error.message,
            })
          }
        }}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <EditableList
            style={{ marginTop: "15px", minHeight: "300px" }}
            scroll={{ x: "30rem" }}
            dataSource={data}
            loading={pageLoading}
            pagination={false}
            rowKey={(m: any) => m.id}
            columns={KZLYWCatalogColumns(
              AXIOS_IP,
              props.token,
              props.visible,
              (text, t) => {
                if (text == "edit") {
                  const result = validateRequiredFields(t, requiredList)
                  const flag =
                    data.findIndex((d) => d.id === t.id) === data.length - 1
                    const newData = data.map((item: any) => {
                      if (item.id == t.id) {
                        return t
                      } else {
                        return item
                      }
                    })

                  setData(
                    result
                      ? newData
                      : flag //判断是否为最新一行，是的就添加一行
                      ? newData.concat([{ id: generateTempId() }])
                      : newData
                  )
                } else if (text === "add") {
                  // const result = validateRequiredFields(t, requiredList)
                  // if (!result) {
                  //   setData([...data, { id: generateTempId() }])
                  // }
                } else if (text == "remove") {
                  const flag = data.findIndex((d) => d.id === t.id) === data.length - 1
                  if (flag) {
                    setData(data.map((item: any) => {
                      if (item.id == t.id) {
                        return { id: generateTempId() }
                      } else {
                        return item
                      }
                    }))
                  } else {
                    setData(data.filter((item: any) => item.id != t.id))
                  }
                }
              }
            )}
            sticky
          />
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const params = {
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            id: !props.isFiling ? props.againId : undefined,
            filingAnticancerDrugRecordId: props.isFiling ? props.againId : undefined,
            memo: props.memo,
            infoDTOList: data?.slice(0, -1)?.map((d: any) => {
              return {
                ...d,
                id: undefined
              }
            })
          }
          axios({
            url: `${AXIOS_IP}/filingReviewAnticancerDrug/saveOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data: params,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>
    </>
  )
}
